const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速追更',
    desc: '漫画最新更新第一时间同步，追更引擎全天候监控全网连载漫画更新动态，确保你总能在第一时间获取新章节发布消息。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '智能提醒',
    desc: '个性化追更提醒设置，支持按漫画、按时间、按更新频率灵活配置。漫画更新提醒精准推送，不错过任何一话。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量覆盖',
    desc: '涵盖国漫、日漫、韩漫等全品类连载漫画追更资源，覆盖热血、悬疑、恋爱、异世界等所有题材，满足各类漫友需求。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '所有漫画更新信息来源均来自正版公开渠道，追更服务免费提供，保护漫友隐私安全，打造值得信赖的漫画追更平台。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫蛙优势
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            为什么选择漫蛙漫画网？四大核心优势让追更体验全面升级
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, i) => (
            <div key={i} className="group p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70 text-center transition-all duration-200 hover:border-primary-200">
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5 ${
                i === 0 ? 'bg-primary-100 text-primary-500' :
                i === 1 ? 'bg-accent-100 text-accent-600' :
                i === 2 ? 'bg-secondary-100 text-secondary-600' :
                'bg-primary-100 text-primary-500'
              }`}>
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}